import { postMultipart } from './helpers';

/** 업로드 결과 — 저장 key 와 공개 URL */
export interface StoredImage {
  storage_key: string;
  url: string;
  original_filename?: string;
}

export const imagesApi = {
  /**
   * 이미지 1건 업로드.
   *
   * 업로드는 전부 백엔드를 경유한다 — 브라우저가 스토리지로 직접 올리던 경로를 없앤 이유는
   * 그 경로가 서버측 전처리(다운스케일 · HEIC 정규화)를 통째로 건너뛰어, 같은 기능인데
   * 업로드 지점에 따라 저장 결과가 달라졌기 때문이다.
   *
   * @param file 업로드할 이미지
   * @param category 폴더 구분 (예: "showroom", "sample-requests", "shipping")
   */
  uploadImage: async (file: File, category: string = 'general'): Promise<StoredImage> => {
    const res = await postMultipart<StoredImage>('/images/upload', { file, category });
    const data = res.data.data;
    if (!data?.url) {
      throw new Error('Upload did not return a URL');
    }
    return data;
  },
};
